
// Vendor
import { Component, Vue, Watch } from 'vue-property-decorator';

// Internal
import { Loading, OrdiniList, OrdiniCards, LoadingTemplateType } from '@/components';
import { OrdineSlim, Utente, FinderOrdini } from '@/models';
import { store, StoreActions, StoreMutations, FiltriOrdini } from '@/store';

@Component({
  components: {
    Loading,
    OrdiniList,
    OrdiniCards
  }
})
export default class Ordini extends Vue {

  get loading() { return store.state.loading; }

  get user() { return store.state.currentUsr; }

  get userIsAdmin() {
    return (
      this.user.roles.find((x: string) => x.toLowerCase() == 'admin') !=
      undefined
    );
  }

  private templates = LoadingTemplateType;

  get pageSize(): number { return store.state.ui.dimensionePaginaListe; }

  get page(): number { return store.state.uiOrdini.pagina; }
  set page(value: number) { this.caricaPaginaOrdini(value); } //store.commit(StoreMutations.SetPaginaListaOrdini, value); }

  get pageCount(): number { return store.state.uiOrdini.totPagine; }
  get numTotOrdini(): number { return store.state.uiOrdini.totOrdini; }

  get vistaLista(): boolean { return store.state.uiOrdini.listView; }

  get ordini(): OrdineSlim[] {
    return store.state.listaOrdini;
  }

  get fornitori(): Utente[] {
    return store.state.fornitori;
  }

  get fornitore(): Utente | undefined {
    return store.state.fornitore;
  }

  get loadTemplateCorrente() : LoadingTemplateType {
    return store.state.uiOrdini.listView ? LoadingTemplateType.TwoLineAvatarList : LoadingTemplateType.Card;
  }

  set fornitore(fornitore: Utente | undefined) {
    store.commit(StoreMutations.SetFornitore, fornitore);
    if (fornitore) {
      this.idFornitore = fornitore.id;
      this.caricaPaginaOrdini(1);
    } else {
      this.idFornitore = '';
      store.commit(StoreMutations.SetOrdini, []);
    }
    //store.dispatch(StoreActions.GetDatiLookupFornitore, this.idFornitore);
  }

  private idFornitore: string = '';

  created(): void {
    if (this.userIsAdmin) {
      this.fornitore = undefined;
      store.dispatch(StoreActions.GetFornitori);
    } else {
      this.idFornitore = this.user.idFornitore;
      this.caricaPaginaOrdini(1);
    }
  }

  private caricaPaginaOrdini(pagina: number): void {

    let parametri: FinderOrdini = new FinderOrdini(this.idFornitore, pagina);
    parametri.ApplicaFiltriOrdini(store.state.uiOrdini.filtri);
    parametri.filterDatiAggiuntiviOrdiniForList = true;
    store.dispatch(StoreActions.GetOrdiniFornitore, parametri);
  }

  @Watch("$store.state.uiOrdini.filtri")
  onCambioFiltri(filtriNew: FiltriOrdini) {
    if(this.idFornitore){
      this.caricaPaginaOrdini(store.state.uiOrdini.pagina);
    }
  }

  private mounted() {
    //store.dispatch(StoreActions.WatchLavorazioniFornitore, this.$auth.user().idFornitore);
  }

  private destroyed() {
    //store.dispatch(StoreActions.UnwatchLavorazioniFornitore, this.$auth.user().idFornitore);
  }
}
